if (!customElements.get("m-product-details-tabs")) {
  class MProductDetailsTabs extends HTMLElement {
    constructor() {
      super();
      this.tabHeaders = Array.from(this.querySelectorAll('.m-tab-header[role="tab"]'));
      this.tabPanels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.tabs = new MinimogTheme.Tabs(this, () => this.syncTabState());
      this.syncTabState();
      this.addEventListener("keydown", (event) => this.onTabKeydown(event));

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (event) => {
          const tabHeader = event && event.target;
          if (!this.contains(tabHeader)) return;
          const index = (tabHeader && Number(tabHeader.dataset.index)) || 0;
          this.tabs && this.tabs.setActiveTab(index);
          this.syncTabState();
        });
      }
    }

    syncTabState() {
      this.tabHeaders.forEach((header, index) => {
        const selected = index === this.tabs.currentActiveIndex;
        header.setAttribute("aria-selected", String(selected));
        header.tabIndex = selected ? 0 : -1;
        if (this.tabPanels[index]) this.tabPanels[index].hidden = !selected;
      });
    }

    onTabKeydown(event) {
      const header = event.target.closest('.m-tab-header[role="tab"]');
      const currentIndex = this.tabHeaders.indexOf(header);
      if (currentIndex < 0) return;

      let nextIndex;
      if (event.key === "ArrowRight") nextIndex = (currentIndex + 1) % this.tabHeaders.length;
      else if (event.key === "ArrowLeft") nextIndex = (currentIndex - 1 + this.tabHeaders.length) % this.tabHeaders.length;
      else if (event.key === "Home") nextIndex = 0;
      else if (event.key === "End") nextIndex = this.tabHeaders.length - 1;
      else return;

      event.preventDefault();
      this.tabs.setActiveTab(nextIndex);
      this.syncTabState();
      this.tabHeaders[nextIndex].focus();
    }
  }
  customElements.define("m-product-details-tabs", MProductDetailsTabs);
}
